module.exports = __webpack_public_path__ + "static/media/21.bbfffa53.jpg";